const { default: styled } = require("styled-components");

export const ModalPaymentInfoContainer = styled.div`
  
.modal-window {
    position: fixed;
    background-color: rgb(0 0 0 / 15%);
    backdrop-filter: blur(1.2px);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s;
    visibility: visible;
      opacity: 1;
      pointer-events: auto;
    /* &:target {
      visibility: visible;
      opacity: 1;
      pointer-events: auto;
    } */
    & > div {
      width: 400px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: 2em;
      background: white;
    }
    header {
      font-weight: bold;
    }
    h1 {
      font-size: 150%;
      margin: 0 0 15px;
    }
  }
  
  .modal-close {
    color: #aaa;
    line-height: 50px;
    font-size: 80%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 0;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
  }
  
  /* Demo Styles */
  
  
  html {
    font-size: 18px;
    line-height: 1.4;
  }
  
  
  a {
    color: inherit;
  }
  
  .container {
    /* display: grid;
    justify-content: center;
    align-items: center; */
    /* height: 100vh; */
  }
  
  .modal-window {
    & > div {
      border-radius: 1rem;
    }
  }
  
  .modal-window div:not(:last-of-type) {
    margin-bottom: 15px;
  }
  
  small {
    color: lightgray;
  }
  
  


    div.list {
    counter-reset: list-number;
    }
    
    div.list div:before {
    counter-increment: list-number;
    content: counter(list-number);
    font-size:0.8rem;
    margin-right: 10px;
    margin-bottom:10px;
    width:35px;
    height:35px;
    display:inline-flex;
    align-items:center;
    justify-content: center;
    font-size:16px;
    background-color: tranparent;
    border: 1px solid #a0e1cc;
    border-radius:50%;
    color:#a0e1cc;
    }

    .btn-payment{
        background-color: #3085d6;
    }


    .footer-modal{
        display:flex;
        justify-content:center;
        align-items:center;
    }
  
  
`